import type { Tool, ToolGroup } from '@/services/Tools';

import { TOOL_LABEL_KEY } from './Tools.constants';

export const groupTools = (items: readonly Tool[]): Map<ToolGroup, Tool[]> => {
	const map = new Map<ToolGroup, Tool[]>();

	items.forEach((tool) => {
		const bucket = map.get(tool.group) ?? [];

		bucket.push(tool);
		map.set(tool.group, bucket);
	});

	return map;
};

export const toolLabelKey = (name: string): string | undefined => TOOL_LABEL_KEY[name];

export const countEnabled = (items: readonly Tool[]): number => items.filter((tool) => tool.enabled).length;
